import {useEffect} from "react";
import {Grid} from "@mui/material";
import {useRecoilValue} from "recoil";
import {representativeInfoState} from "../../../../../search-repair-shop/state";
import {useForm} from "react-hook-form";
import {useTranslation} from "react-i18next";
import FormTextField from "../../../../../common/form-fields-wrappers/FormTextField";
import { setValuesInForm } from "../../../../constants";
import { RepresentativeInfoForm } from "./types";

const RepresentativeInfo = () => {
    const {t} = useTranslation(["network", "translation"]);
    const representativeInfo = useRecoilValue(representativeInfoState);
    const representativeInfoForm = useForm<RepresentativeInfoForm>({defaultValues: {
        id: representativeInfo?.id ?? -1,
        bpCodeRepresentative :representativeInfo?.bpCodeRepresentative ?? '',
        companyName :representativeInfo?.companyName ?? '',
        nameAndSurnameOfRepresentative :representativeInfo?.nameAndSurnameOfRepresentative ?? '',
        emailOfRepresentative :representativeInfo?.emailOfRepresentative ?? '',
        prefixCellPhoneNumberOfRepresentative :representativeInfo?.prefixCellPhoneNumberOfRepresentative ?? '',
        cellPhoneNumberOfRepresentative :representativeInfo?.cellPhoneNumberOfRepresentative ?? '',
        vatNumber :representativeInfo?.vatNumber ?? '',
        siren: representativeInfo?.siren ?? '',
        siret: representativeInfo?.siret ?? '',
        taxCode :representativeInfo?.taxCode ?? '',
        iban :representativeInfo?.iban ?? '',
        sdiCode :representativeInfo?.sdiCode ?? '',
        nameAndSurnameOfTheContactPerson :representativeInfo?.nameAndSurnameOfTheContactPerson ?? '',
        emailOfTheContactPerson :representativeInfo?.emailOfTheContactPerson ?? '',
        prefixCellPhoneNumberOfTheContactPerson :representativeInfo?.prefixCellPhoneNumberOfTheContactPerson ?? '',
        cellPhoneNumberOfTheContactPerson :representativeInfo?.cellPhoneNumberOfTheContactPerson ?? '',
        address :representativeInfo?.address ?? '',
        streetNumber :representativeInfo?.streetNumber ?? '',
        postalCode :representativeInfo?.postalCode ?? '',
        city :representativeInfo?.city ?? '',
        province :representativeInfo?.province ?? '',
        prefixHoCellPhoneNumber :representativeInfo?.prefixHoCellPhoneNumber ?? '',
        hoCellPhoneNumber :representativeInfo?.hoCellPhoneNumber ?? '',
        pec :representativeInfo?.pec ?? '',
        
    }});

    useEffect(() => {
        if (!!representativeInfo){
            setValuesInForm(representativeInfo, representativeInfoForm);
        }
    }, [representativeInfo]);

    return (
        <Grid container direction="row" alignItems="start">
            <Grid container item direction="row" xs={12} columnSpacing={2}>
                <Grid item xs={12} sm={6} md={3}>
                    <FormTextField
                        disabled
                        control={representativeInfoForm.control}
                        name="bpCodeRepresentative"
                        label={t('rsDetail.representativeInfo.form.label.representativeIdentificationCode')}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <FormTextField
                        disabled
                        control={representativeInfoForm.control}
                        name="companyName"
                        label={t('rsDetail.representativeInfo.form.label.companyName')}
                    />
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                    <FormTextField
                        disabled
                        control={representativeInfoForm.control}
                        name="nameAndSurnameOfRepresentative"
                        label={t('rsDetail.representativeInfo.form.label.nameAndSurnameOfRepresentative')}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <FormTextField
                        disabled
                        control={representativeInfoForm.control}
                        name="emailOfRepresentative"
                        label={t('rsDetail.representativeInfo.form.label.emailOfRepresentative')}
                    />
                </Grid>
                <Grid item container xs={12} sm={6} md={3}>
                    <FormTextField
                        disabled
                        control={representativeInfoForm.control}
                        name="cellPhoneNumberOfRepresentative"
                        label={t('rsDetail.representativeInfo.form.label.cellPhoneNumberOfRepresentative')}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <FormTextField
                        disabled
                        control={representativeInfoForm.control}
                        name="vatNumber"
                        label={t('rsDetail.representativeInfo.form.label.vatNumber')}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <FormTextField
                        disabled
                        control={representativeInfoForm.control}
                        name="siren"
                        label={t('rsDetail.representativeInfo.form.label.siren')}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <FormTextField
                        disabled
                        control={representativeInfoForm.control}
                        name="siret"
                        label={t('rsDetail.representativeInfo.form.label.siret')}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <FormTextField
                        disabled
                        control={representativeInfoForm.control}
                        name="taxCode"
                        label={t('rsDetail.representativeInfo.form.label.taxCode')}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <FormTextField
                        disabled
                        control={representativeInfoForm.control}
                        name="iban"
                        label={t('rsDetail.representativeInfo.form.label.iban')}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <FormTextField
                        disabled
                        control={representativeInfoForm.control}
                        name="sdiCode"
                        label={t('rsDetail.representativeInfo.form.label.sdiCode')}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <FormTextField
                        disabled
                        control={representativeInfoForm.control}
                        name="nameAndSurnameOfTheContactPerson"
                        label={t('rsDetail.representativeInfo.form.label.nameAndSurnameOfTheContactPerson')}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <FormTextField
                        disabled
                        control={representativeInfoForm.control}
                        name="emailOfTheContactPerson"
                        label={t('rsDetail.representativeInfo.form.label.emailOfTheContactPerson')}
                    />
                </Grid>
                <Grid item container xs={12} sm={6} md={3}>
                    <FormTextField
                        disabled
                        control={representativeInfoForm.control}
                        name="cellPhoneNumberOfTheContactPerson"
                        label={t('rsDetail.representativeInfo.form.label.cellPhoneNumberOfTheContactPerson')}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <FormTextField
                        disabled
                        control={representativeInfoForm.control}
                        name="address"
                        label={t('rsDetail.representativeInfo.form.label.address')}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <FormTextField
                        disabled
                        control={representativeInfoForm.control}
                        name="streetNumber"
                        label={t('rsDetail.representativeInfo.form.label.streetNumber')}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <FormTextField
                        disabled
                        control={representativeInfoForm.control}
                        name="postalCode"
                        label={t('rsDetail.representativeInfo.form.label.postalCode')}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <FormTextField
                        disabled
                        control={representativeInfoForm.control}
                        name="city"
                        label={t('rsDetail.representativeInfo.form.label.city')}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <FormTextField
                        disabled
                        control={representativeInfoForm.control}
                        name="province"
                        label={t('rsDetail.representativeInfo.form.label.province')}
                    />
                </Grid>
                <Grid item container xs={12} sm={6} md={3}>
                    <FormTextField
                        disabled
                        control={representativeInfoForm.control}
                        name="hoCellPhoneNumber"
                        label={t('rsDetail.representativeInfo.form.label.hoCellPhoneNumber')}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <FormTextField
                        disabled
                        control={representativeInfoForm.control}
                        name="pec"
                        label={t('rsDetail.representativeInfo.form.label.pec')}
                    />
                </Grid>
            </Grid>
        </Grid>
    )
}

export default RepresentativeInfo;
